export const BENEFIT_CONSULTANTS = [
  'Langston University',
  'Texas A&M University',
  'Nelson University TX',
  'Arkansas Baptist University',
  'Jarvis Baptist University',
  'Nelson Indian University AZ',
  'Black Heart Association 🖤',
  'Abounding Prosperity',
  'APG- security company',
  'Latrice Harris',
  'Junnell Wright',
  'Deacon Jones',
  'Pamela Ford',
  'Steven Green',
  'Giles Ysaguirre',
  'Barneshia Henderson',
  'Juanita Allen',
  'Mandy Cox Hillsboro Hospital',
  'Cache Palmer/ Gifted Souls',
  'Jina Potts',
  'Zakerra Jackson',
  'Ladasha Fincher',
  'Yasmeen Mir',
  'Diamond Moss',
  'Michelle Watkins',
  'Cache Palmer',
  'Tammie Baker',
  'Daphne Coleman',
  'Gifted Souls Clinic/ Sky Wheeler',
  'Michelle Mosley',
  'Ambria Odum',
  'Reginald Wide',
  'Derrick Criswell',
  'Temekia Gildon',
  'Brioni',
  'Rosalind Shea',
  'Rodney Washington',
  'Nick Horton',
  'Nikka- Philippines',
  'Andrew- Philippines'
];

export const GENDERS = ['Male', 'Female'];

export const HOUSEHOLD_SIZES = [
  'Member',
  'Member and Spouse',
  'Child/ not on Medicaid, Chip or MediCal',
  'More than one child / Not on Government ASST',
  'More than 5 Children'
];

export const DEPENDENT_RELATIONSHIPS = ['Spouse', 'Child', 'Other'];

export const MONTHLY_INCOMES = [
  '$1400-$1600',
  '$1700-$1800',
  '$1900-$2000',
  '$2100-$2500',
  '$2600-$3000',
  '$3100-$4000',
  '$4100-$5000',
  '$5100-$6000',
  '$6100-$7000',
  '$7100-Above'
];

export const INSURANCE_CARRIERS = [
  'Aetna Health',
  'Ambetter Health',
  'Blue Cross',
  'Cigna',
  'Humana Health',
  'Krieser Health',
  'Molina Health',
  'WellCare Health',
  'WellPoint'
];

export const YES_NO = ['Yes', 'No'];

export const ENROLLMENT_LOCATIONS = [
  'Langston University',
  'Texas A&M University',
  'Nelson University TX',
  'Arkansas Baptist University',
  'Jarvis Baptist University',
  'Nelson Indian University AZ',
  'Black Heart Association 🖤',
  'Abounding Prosperity',
  'Hillsboro Hospital',
  'Crescent Hospital',
  'Dr. Tina Clinic',
  'Dr. Nicole Clinic',
  'Cedar Spring Clinic',
  'Joseph Gathe Clinic',
  'Gifted Souls MHMR Clinic',
  'Abounding Prosperity Clinic',
  'Other'
];

export const MAX_DEPENDENTS = 15;

export const AGENT = {
  company: 'Wright-Care Benefits',
  name: 'Junnell Wright',
  npn: '14761754',
  phone: '+1-877-622-5136',
  phoneHref: 'tel:+18776225136',
  email: 'Junnellwright@wrightcarebenefits.com'
};

export const INCOME_DISCLAIMER_INTRO =
  'To apply for health coverage and potentially qualify for financial assistance, you may need to report your expected household income for the coverage year. Income may come from various sources, including:';

export const INCOME_SOURCES = [
  'Wages from a regular job',
  'Self-employment income',
  'Independent contractor or 1099 income',
  'Certain unemployment benefits',
  'Income from eligible household or family members',
  'Certain taxable scholarship or educational income, when applicable',
  'Other qualifying sources of income'
];

export const INCOME_DISCLAIMER_OUTRO =
  'Please report your income accurately. Not every type of payment, scholarship, housing benefit, meal plan, or financial assistance is considered Marketplace income. Wright Care Benefits can assist you with determining what information and documentation may be needed for your health coverage application.';

export const CONSENT_INTRO =
  'I give my permission to Wright-Care Benefits to serve as my health insurance agent for myself and my entire household if applicable, for purposes of enrollment in a Qualified Health Plan offered on the Federally Facilitated Marketplace. By consenting to this agreement, I authorize the above-mentioned agent to view and use the confidential information provided by me in writing, electronically, or by telephone only for the purposes of one or more of the following:';

export const CONSENT_PURPOSES = [
  'Searching for an existing Marketplace application.',
  'Completing an application for eligibility and enrollment in a Marketplace Qualified Health Plan or other government insurance affordability programs, such as Medicaid and CHIP or advance tax credits to help pay for Marketplace premiums.',
  'Providing ongoing account maintenance and enrollment assistance, as necessary.',
  'Responding to inquiries from the Marketplace regarding my Marketplace application.',
  'If you already have a Marketplace plan, you give permission to switch you to a better plan if one is available; if you are already on the best plan possible you are requesting Junnell Wright (Wright-Care Benefits) to take over as your agent of record from this point forward unless notified of a change.',
  'I agree that if I am making less than 100% of the federal poverty line that I am looking for work making at least minimum wage.'
];

export const CONSENT_OUTRO =
  'I understand that the agent will not use or share my personal identifiable information (PII) for any purposes other than those listed above. The Agent will ensure my PII is kept private and safe when collecting, storing, and using my PII for stated purposes above. I confirm that the information I provided for entry on my Marketplace eligibility and enrollment application will be true to the best of my knowledge. I understand that I do not have to share additional personal information about myself or my health with my Agent beyond what is required on the application for eligibility and enrollment purposes. I understand that my consent remains in effect until I revoke it, and I may revoke or modify my consent at any time by sending an email, text, or phone call to Wright-Care Benefits at +1-877-622-5136.';

export const STATUS_OPTIONS = [
  { value: 'new', label: 'New', color: 'blue' },
  { value: 'in_progress', label: 'In progress', color: 'gold' },
  { value: 'enrolled', label: 'Enrolled', color: 'green' },
  { value: 'not_eligible', label: 'Not eligible', color: 'default' },
  { value: 'closed', label: 'Closed', color: 'default' }
];
